module.exports = __webpack_public_path__ + "static/media/SAF-MARINE.1283202e.svg";